import {Repository, createRepository} from '@/repositories/Base/Repository'

class RndsRepository extends Repository {
    endpoint = 'integration/rnds-logs'

    post(params) {
        return this.$axios.post(`integration/sus_rnds`, params, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
    }
}

export default new RndsRepository()

export const create = createRepository(RndsRepository)
